import { Linking } from 'react-native'

export const openURL = (url: string) => {
  Linking.openURL(url).catch((err) =>
    console.error(`Can't open the link!`, err)
  )
}
